import type { Message } from '../types';

interface ChatMessageProps {
  message: Message;
}

export const ChatMessage = ({ message }: ChatMessageProps) => {
  try {
    return (
      <div className={`flex ${message.isUser ? 'justify-end' : 'justify-start'} mb-4`}>
        <div
          className={`max-w-[276px] px-4 py-2 text-white rounded-[10px] ${
            message.isUser ? 'bg-[#132832]' : 'bg-[#2E5C70]'
          }`}>
          {message.isUser ? (
            <p className="text-xs font-semibold mb-1"></p>
          ) : message.speakerName && (
            <p className="text-xs font-semibold mb-1">AI {message.speakerName}</p>
          )}
          {message.text ? (
            <p className="text-sm">{message.text}</p>
          ) : (
            <div className="flex items-center space-x-1">
              <div className="flex space-x-1">
                <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                <div className="w-2 h-2 bg-white rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
              </div>
            </div>
          )}
          <p className="text-xs opacity-70 mt-1">
            {message.timestamp?.toLocaleTimeString() || 'Unknown time'}
          </p>
        </div>
      </div>
    );
  } catch (error) {
    console.error('Error rendering message:', error);
    return (
      <div className="flex justify-start mb-4">
        <div className="max-w-[276px] px-4 py-2 text-red-500 bg-red-100 rounded-[10px]">
          <p className="text-sm">Error displaying message</p>
        </div>
      </div>
    );
  }
};